import { render, staticRenderFns } from "./ClientiDetails.vue?vue&type=template&id=c058c7e6&scoped=true"
import script from "./ClientiDetails.vue?vue&type=script&lang=js"
export * from "./ClientiDetails.vue?vue&type=script&lang=js"
import style0 from "./ClientiDetails.vue?vue&type=style&index=0&id=c058c7e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c058c7e6",
  null
  
)

export default component.exports